// extracted by css-extract-rspack-plugin
export default {"container":"KeyNavigationHandlerContainer_container__wE-JG"};